import React, { createContext, useContext, useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getList } from '@app/apis/schools';
import { getCurrentUser } from '@app/utils/utils';

const SchoolContext = createContext({
    listSchool: [],
    loading: false,
    error: null,
    refetch: () => {},
});

export const SchoolProvider = ({ children }) => {
    const currUser = getCurrentUser();
    const {
        data: listSchool = [],
        isLoading: loading,
        error,
        refetch,
    } = useQuery({
        queryKey: ['schools', currUser.o_id],
        queryFn: async () => {
            const { status, data } = await getList();
            if (status === 200 && data?.data) {
                return data.data;
            }
            return [];
        },
    });

    const value = useMemo(
        () => ({
            listSchool,
            loading,
            error,
            refetch,
        }),
        [listSchool, loading, error, refetch],
    );

    return (
        <SchoolContext.Provider value={value}>
            {children}
        </SchoolContext.Provider>
    );
};

/** Hook tiện ích để lấy dữ liệu từ SchoolContext */
export const useSchoolContext = () => {
    const context = useContext(SchoolContext);
    if (!context) {
        throw new Error(
            'useSchoolContext phải được dùng bên trong SchoolProvider',
        );
    }
    return context;
};

export default SchoolContext;
